import { AfterViewChecked, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { DetailsInitInfo, ItemEventInfo } from './data-structures';
import { ClientDTO } from 'src/app/base/models/models.swagger.generated';
import { ClientService } from 'src/app/base/services/client/client.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TreeViewZoneBasedComponent } from './tree-views/tree-view-zone-based/tree-view-zone-based.component';
import { TreeViewConfigBasedComponent } from './tree-views/tree-view-config-based/tree-view-config-based.component';
import { ITreeViewComponent } from './tree-views/tree-view.interface';
import { AuthService } from 'src/app/base/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { AdministrationDetailsComponent } from './administration-details/administration-details.component';
import { YesNoGroupButtonComponent } from '../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { ClientAutocompleteComponent } from '../../../base/shared/client-autocomplete/client-autocomplete.component';
import { NgIf } from '@angular/common';
import { TitleBarComponent } from '../../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-administration',
    templateUrl: './administration.component.html',
    styleUrls: ['./administration.component.scss'],
    standalone: true,
    imports: [TitleBarComponent, NgIf, ClientAutocompleteComponent, YesNoGroupButtonComponent, ReactiveFormsModule, TreeViewZoneBasedComponent, TreeViewConfigBasedComponent, AdministrationDetailsComponent, TranslateModule]
})
export class AdministrationComponent implements AfterViewChecked {
  @ViewChild(TreeViewZoneBasedComponent) public zoneBasedTreeView: TreeViewZoneBasedComponent;
  @ViewChild(TreeViewConfigBasedComponent) public configBasedTreeView: TreeViewConfigBasedComponent;

  public selectedItem: DetailsInitInfo = null;

  public isZoneModeControl: FormControl<boolean> = new FormControl<boolean>(true);

  public hasPendingDetailChanges: boolean = false;

  public get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public set selectedClient(value: ClientDTO) {
    this.clientService.selectedClient = value;
    this.onClientSelected(value);
  }

  public get isClientAdminView(): boolean {
    return this.authService.hasUserClientAssigned();
  }

  private get activeTreeView(): ITreeViewComponent {
    return this.isZoneModeControl.value ? this.zoneBasedTreeView : this.configBasedTreeView;
  }

  constructor(private clientService: ClientService, private authService: AuthService, private cdr: ChangeDetectorRef) {
    this.isZoneModeControl.valueChanges.subscribe((value) => {
      this.selectedItem = null;
    });
  }

  public ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  public onItemSelected(data: DetailsInitInfo) {
    this.selectedItem = data;
  }

  public onDetailCancel() {
    if (this.isZoneModeControl.value) {
      this.zoneBasedTreeView?.resetSelection();
    } else {
      this.configBasedTreeView?.resetSelection();
    }
  }

  public onItemCreated(eventInfo: ItemEventInfo) {
    this.hasPendingDetailChanges = false;
    this.activeTreeView?.addNode(eventInfo);
  }

  public onItemUpdated(eventInfo: ItemEventInfo) {
    this.hasPendingDetailChanges = false;
    this.activeTreeView?.updateNode(eventInfo);
  }

  public onItemDeleted(eventInfo: ItemEventInfo) {
    this.hasPendingDetailChanges = false;
    this.activeTreeView?.removeNode(eventInfo);
  }

  public onHasPendingDetailChanges(hasPendingDetailChanges: boolean) {
    this.hasPendingDetailChanges = hasPendingDetailChanges;
  }

  private onClientSelected(client: ClientDTO) {
    this.activeTreeView?.reset();
    this.selectedItem = null;
    this.hasPendingDetailChanges = false;
  }
}
